export default "__VITE_ASSET__9baded75__"